export const getStringFieldValue = (value: unknown): string | null => {
	if (typeof value === 'string') return value;
	if (typeof value === 'number') return value.toString();
	if (Array.isArray(value)) return value[0].toString();
	return null;
};

export const getForgeObjectFieldValue = (value: unknown): string => {
	return JSON.stringify(value);
};
